import WatchMovie from "./WatchMovie";

export default WatchMovie;
